import { render, staticRenderFns } from "./realTimeMonitor.vue?vue&type=template&id=bb6a10a6"
import script from "./realTimeMonitor.vue?vue&type=script&lang=js"
export * from "./realTimeMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports